import React, { Fragment } from 'react';

import MaterialTable from 'material-table';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import PickupOrderListItem from '../../../models/PickupOrderListItem';
import OrderWhsDetails from '../../../models/OrderWhsDetails';
import commonStyles from '../../common/common.module.css';
import style from './whsOrdersList.module.css';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, Paper } from '@material-ui/core';

const styles = (theme: Theme) =>

  createStyles({
    wrapper: {
      border: '1px solid rgba(9, 43, 74, 1)',
      paddingTop: '25px',
      boxShadow: '2px 2px 5px rgb(0 0 0 / 35%)',
      borderRadius: '15px',
      position: 'relative',
      marginBottom: '30px',
      paddingBottom: '25px',
      backgroundColor: 'white',
    },
    PoD: {
      color: 'inherit',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    awbActionsList: {
      display: 'flex',
      flexDirection: 'row',
      width: '95%',
      justifyContent: 'space-between'
    },
    green: {
      backgroundColor: 'green !important',
      color: 'white',
      fontSize: '10px',
      padding: '3px',
      borderRadius: '3px',
      margin: '0',
      cursor: 'pointer',
    },
    red: {
      backgroundColor: 'red !important',
      color: 'white',
      fontSize: '10px',
      padding: '3px',
      borderRadius: '3px',
      margin: '0',
      cursor: 'pointer',
    },
    materialIcon: {
      padding: '0px 6px 0px',
      fontSize: '20px',
    },
    specials: {
      display: 'flex',
      flexDirection: 'column',
    },
    gap4px: {
      gap: '4px',
    },
    header: {
      marginLeft: '5%',
      marginTop: '2%'
    },
    flexSpcl: {
      flexWrap: 'nowrap'
    },
    '@media (max-width: 991px)': {
      flexSpcl: {
        flexWrap: 'wrap'
      },
    }
  });

interface WhsDoDetailsTableProps {
  classes: any;
  dropOffOrder: OrderWhsDetails;
  closeDialog: Function;
};


const awbListTable = (props: WhsDoDetailsTableProps) => {

  const { dropOffOrder } = props;

  return (
    <div className={ `${ style.bkgOverlay }` }>
      <div className={ `${ style.dialogContainer }` }>
        <h3 className={ `${ commonStyles.header } ${ props.classes.header }` }> </h3>
        <div className={ `${ style.dialogTitle } ${ commonStyles.mx4 }` }>
          <span className={ `${style.name } ${ commonStyles.ml0 }` }>AWB Details</span>
          <IconButton aria-label="Close" className={ style.close }>
            <CloseIcon color='primary' onClick={ () => props.closeDialog() } />
          </IconButton>
        </div>
        <div className={ `${ commonStyles.wrapper } ${ commonStyles.m4 } ${ commonStyles.pb0 }` }>
          <MaterialTable
            data={ dropOffOrder.list } 

            components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

            columns={[
      
            { title: 'Awb', field: 'awb', cellStyle: { padding: 0, margin: 0 }, headerStyle: { padding: '10px 0 10px 0', height: '1%' },
              render: (rowData: PickupOrderListItem) => { 

              return <span>{ rowData.code }-{ rowData.number }  {rowData.returned? <span style={{color: 'red'}}>Returned to driver</span>: null}</span>;
              }
            },
            { title: 'SPL', field: 'awb', cellStyle: { padding: 0, margin: 0, width: '20%' }, headerStyle: { padding: '10px 0 10px 0', width: '20%', height: '1%' },
            render: (rowData: PickupOrderListItem) => { 

              return<span className={`${ commonStyles.dFlex } ${ props.classes.flexSpcl } ${ props.classes.gap4px }`}>
                { rowData.special_form_data ? rowData.special_form_data.specials_form_data.map((special: any) => {
                  if (special.value) {
                    return (
                      <span className={ props.classes.specials }>
                        <div style={{ backgroundColor: special.color, border: special.border ? `dashed 2px ${special.border}` : ''    }} className={`${ commonStyles.specials }`}><div className={ commonStyles.colorPrimary }>{special.name}</div>
                        </div>
                        <span className={ commonStyles.spTemp }>{special.temp ? special.temp : ''}</span>
                      </span>
                    )
                  }

                }) : null }
                {  rowData.special_form_data && rowData.special_form_data.other.name.length ? 
                rowData.special_form_data.other.name.map(others =><div style={{ backgroundColor: '#ffffff', border: '1px solid var(--primaryblue)', color: 'var(--primaryblue)' }} className={`${commonStyles.specials}`}>{others}</div>)
              : null }
              </span>;
            }
            },
            { title: 'Pcs', field: 'pieces', cellStyle: { padding: 0, margin: 0, width: '10%' }, headerStyle: { padding: '10px 0 10px 0', width: '10%', height: '1%' } },
            { title: 'Dst', field: 'dst', cellStyle: { padding: 0, margin: 0, width: '10%' }, headerStyle: { padding: '10px 0 10px 0', width: '10%', height: '1%' } },
          ]}

            options={{
              paging: false,
              pageSize: 10,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2,
              },
              showTitle: false,
              pageSizeOptions: [15, 20],
              toolbar: false,
              sorting: false
            }}
          />
        </div>
        
      </div>
      
    </div>
  );
};

export default withStyles(styles)(awbListTable);